var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormPart',{attrs:{"Item":_vm.TicketItem,"setItemForm":_vm.setItemForm,"submitData":_vm.submitData},on:{"onSuccess":_vm.onSuccess,"onFail":_vm.onFail},scopedSlots:_vm._u([{key:"default",fn:function({
        errors,
        ItemForm,
        submit
      }){return [_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-text-field',{attrs:{"error-messages":errors.maxTimeSpend,"filled":true,"dense":true,"hide-details":"auto","label":"Maximálny odpracovaný čas","type":"number","suffix":"h"},on:{"change":submit},model:{value:(ItemForm.maxTimeSpend),callback:function ($$v) {_vm.$set(ItemForm, "maxTimeSpend", $$v)},expression:"ItemForm.maxTimeSpend"}})],1)],1)]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }